/* Drag&Drop B2B / Trade v2 — 2026-10-25
   - sticky page menu sits under the store header and highlights the visible section
   - charts grow into view
   - the price-range chart refreshes its counts live from the store's price filter */
(function () {
  'use strict';
  var root = document.querySelector('[data-ddb2]');
  if (!root) return;
  root.classList.add('ddb2-js');

  /* same thousands separator as the Liquid output (keeps Latin digits in every language) */
  var sep = root.getAttribute('data-sep') || '.';
  var fmt = { format: function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); } };
  var reduced = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    /reduce/.test(document.documentElement.getAttribute('data-dd-motion') || '');

  /* sticky offset: stack under any header that stays fixed/sticky at the top */
  function headerOffset() {
    var bottom = 0;
    var candidates = document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group > *, header');
    for (var i = 0; i < candidates.length; i++) {
      var cs = getComputedStyle(candidates[i]);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var r = candidates[i].getBoundingClientRect();
      if (r.top <= 1 && r.bottom > bottom && r.height < window.innerHeight / 2) bottom = r.bottom;
    }
    root.style.setProperty('--ddb2-top', Math.max(0, Math.round(bottom)) + 'px');
  }
  headerOffset();
  window.addEventListener('resize', headerOffset, { passive: true });
  window.addEventListener('load', headerOffset);

  /* active menu item */
  var links = Array.prototype.slice.call(root.querySelectorAll('.ddb2-nav a[href^="#"]'));
  var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  if ('IntersectionObserver' in window) {
    var visible = {};
    var navIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting ? e.intersectionRatio : 0; });
      var best = null, bestRatio = 0;
      targets.forEach(function (t) { if (t && visible[t.id] > bestRatio) { best = t.id; bestRatio = visible[t.id]; } });
      links.forEach(function (a) { a.classList.toggle('is-active', !!best && a.getAttribute('href') === '#' + best && !a.classList.contains('ddb2-nav__cta')); });
    }, { rootMargin: '-35% 0px -55% 0px', threshold: [0, 0.01, 0.5, 1] });
    targets.forEach(function (t) { if (t) navIo.observe(t); });
  }

  /* charts grow into view */
  var anims = root.querySelectorAll('.ddb2-anim');
  if (reduced || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(anims, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(anims, function (el) { io.observe(el); });
  }

  /* live price bands */
  var priceChart = root.querySelector('[data-ddb2-price]');
  if (!priceChart || !window.fetch) return;
  var base = priceChart.getAttribute('data-url');
  var items = Array.prototype.slice.call(priceChart.querySelectorAll('[data-gte]'));
  var CACHE = 'ddb2.price.v1';

  function paint(counts) {
    var max = Math.max.apply(null, counts.concat([1]));
    items.forEach(function (li, i) {
      var n = counts[i];
      if (typeof n !== 'number' || isNaN(n)) return;
      li.style.setProperty('--v', Math.max(2, Math.round(n / max * 100)));
      var v = li.querySelector('[data-value]');
      if (v) v.textContent = fmt.format(n);
      li.setAttribute('aria-label', (li.getAttribute('data-label') || '') + ': ' + fmt.format(n));
    });
  }

  function load() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE) || 'null');
      if (cached && Date.now() - cached.t < 6 * 3600 * 1000 && cached.c.length === items.length) { paint(cached.c); return; }
    } catch (e) {}
    Promise.all(items.map(function (li) {
      var url = base + (base.indexOf('?') < 0 ? '?' : '&') + 'section_id=dd-b2b-count' +
        '&filter.v.price.gte=' + encodeURIComponent(li.getAttribute('data-gte')) +
        (li.getAttribute('data-lte') ? '&filter.v.price.lte=' + encodeURIComponent(li.getAttribute('data-lte')) : '');
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var m = html.match(/data-dd-b2b-count[^>]*>\s*(\d+)/);
        return m ? parseInt(m[1], 10) : NaN;
      }).catch(function () { return NaN; });
    })).then(function (counts) {
      if (counts.some(isNaN)) return;
      paint(counts);
      try { sessionStorage.setItem(CACHE, JSON.stringify({ t: Date.now(), c: counts })); } catch (e) {}
    });
  }

  if ('IntersectionObserver' in window) {
    var once = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      once.disconnect();
      load();
    }, { rootMargin: '300px 0px' });
    once.observe(priceChart);
  } else {
    load();
  }
})();